import {
  Text,
  Icons,
  Card,
} from "../../design";
import { PROVINCE_DICT, COUNTRY_DICT } from '../../utils/countries';
import { translate, translateIntervals } from "../../utils/translations";

function SubscriptionGroupCard(props: any) {
  return (
    <Card body={true}>
      <div className="mb-2">
        {props.group.shipping_address ? (
          <div>
            <Text.P2>{props.group.shipping_address.first_name ? props.group.shipping_address.first_name + " " : ""}{props.group.shipping_address.last_name ? props.group.shipping_address.last_name : ""}</Text.P2>
            <Text.P2>{props.group.shipping_address.company ? props.group.shipping_address.company : null}</Text.P2>
            <Text.P2>{props.group.shipping_address.address1}</Text.P2>
            <Text.P2>{props.group.shipping_address.address2}</Text.P2>
            <Text.P2>{props.group.shipping_address.city ? props.group.shipping_address.city + ", " : ""} {props.group.shipping_address.country_code && props.group.shipping_address.province_code ? PROVINCE_DICT[props.group.shipping_address.country_code][props.group.shipping_address.province_code] + ", " : ""}{props.group.shipping_address.zip}</Text.P2>
            <Text.P2>{COUNTRY_DICT[props.group.shipping_address.country_code]}</Text.P2>
            <Text.P2>{props.group.shipping_address.phone ? props.group.shipping_address.phone : null}</Text.P2>
          </div>
        ) : (
            <Text.P2>{translate('shipping_address_na')}</Text.P2>
          )}
      </div>
      <div className="mb-2">
        {translate('merge_subscription_count_label', { subscriptions_count: props.group.contracts.filter((contract: any) => !contract.isDigitalSubscription).length })}
      </div>
      <div className="d-flex align-items-center">
        <Icons.Repeat />
        <Text.P2 className="ms-1">
          {props.group.delivery_policy.interval_count == props.group.billing_policy.interval_count ? translate('subscription_plan_nonprepaid_label', {
            delivery_interval: translateIntervals(props.group.delivery_policy.interval_count, props.group.delivery_policy.interval.toLowerCase())
          }) : translate('subscription_plan_prepaid_label', {
            delivery_interval: translateIntervals(props.group.delivery_policy.interval_count, props.group.delivery_policy.interval.toLowerCase()),
            billing_interval: translateIntervals(props.group.billing_policy.interval_count, props.group.billing_policy.interval.toLowerCase())
          })}
        </Text.P2>
      </div>
    </Card>
  );
}


export default SubscriptionGroupCard;
